import React, { useEffect, useState } from 'react';
import { Dropdown, Image } from 'react-bootstrap';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { connect } from 'react-redux';

import CustomSwitchButton from 'components/base/CustomSwitchButton';
import ErrorFieldMessage, {
  CustomErrorMessage,
  hasReactHookFormError,
} from 'components/base/ErrorFieldMessage';
import BasePrompt from 'components/base/prompt/BasePrompt';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import EarningRuleDropdownWithButtonAndPrompt from 'components/campaign/campaignCreation/EarningRuleDropdownWithButtonAndPrompt';
import {
  ACCOUNT_STATUS_TYPE,
  DISPLAY_ACCOUNT_STATUS_TYPE,
  EarningRuleType,
  GenderOptions,
  MonthOptions,
  PERIOD_TYPE_DISPLAY,
  SEGMENT_TYPE,
} from 'config/CustomEnums';
import {
  contentEnum,
  contentGroupEnum,
  scoreDefinitionList,
  scoreDefinitionNameList,
} from 'models/SegmentModel';

import { OnlyDropdown } from 'components/base/ActionsDropdown';
import AdditionalDataSection from './AdditionalDataSection';
import CampaignBehavioralSection from './CampaignBehavioralSection';
import CouponBehavioralSection from './CouponBehavioralSection';
import DiscountLoverSection from './DiscountLoverSection';
import DropdownToMutipleSelector from './DropdownToMutipleSelector';
import InputWithMutipleDropDown from './InputWithMutipleDropDown';
import LastPurchaseSection from './LastPurchaseSection';
import LookupWithMutipleNumber from './LookupWithMutipleNumber';
import MessageTrackingSection from './MessageTrackingSection';
import NumberOfTransactionSection from './NumberOfTransactionsSection';
import PointsToExpireSection from './PointsToExpireSection';
import ProductCategoryMultipleSelector from './ProductCategoryMultipleSelector';
import ProgressionPointsReachTargetSection from './ProgressionPointsReachTargetSection';
import PurchaseInStoreSection from './PurchaseInStoreSection';
import SignUpEmailDomainSection from './SignUpEmailDomainSection';
import TransactionTypeMutipleSelector from './TransactionTypeMutipleSelector';
import LevelSoonExpireSection from './LevelSoonExpireSection';

import 'utils/BtnCommonTheme.scss';

import DeleteIcon from 'assets/images/deleteIcon.png';
import Search from 'assets/images/drop_down_filter.svg';
import NarrowUp from 'assets/images/drop_down_not_show_narrow.svg';

import './Segment.scss';
import { tierTypeConfig } from 'config/TierTypeConfig';

const contentSections = {
  Demographic: [
    contentEnum.gender,
    contentEnum.birthday,
    contentEnum.age,
    contentEnum.countryCode,
    contentEnum.signupAnniversary,
  ],
  Account: [
    contentEnum.level,
    contentEnum.levelSoonToExpire,
    contentEnum.ppAlmostReachTarget,
    contentEnum.newMember,
    contentEnum.newSignupWithReferral,
    contentEnum.newSignupWithPromotionCode,
    contentEnum.emailDomain,
    contentEnum.numberOfLogin,
    contentEnum.lastLogin,
    contentEnum.accountStatus,
  ].filter(option => {
    if (!tierTypeConfig.levels && option === contentEnum.level) {
      return false;
    }
    return true;
  }),
  Behavioral: [
    contentEnum.lastPurchase,
    contentEnum.numberOfTransaction,
    contentEnum.discountLover,
    contentEnum.totalSpending,
    contentEnum.averageTransaction,
    contentEnum.purchaseInStore,
    contentEnum.eComBindStatus,
    contentEnum.products,
    contentEnum.productCategory,
    contentEnum.campaignViewed,
    contentEnum.acquireOrUsedCoupon,
    contentEnum.earnReward,
    contentEnum.totalPointsEarned,
    contentEnum.pointsToExpire,
    contentEnum.messageTracking,
  ],
  RFM: scoreDefinitionNameList,
  'Additional data': [
    contentEnum.additionalDataFromCustomers,
    contentEnum.additionalDataFromTransactionRecords,
    contentEnum.additionalDataFromPurchasedItems,
  ],
};

function ContentFilterDropDown({
  show,
  sectionSelectAction = (() => { }),
  settedParams = [],
}) {
  const [isOpen, setIsOpen] = useState({
    Demographic: false,
    Behavioral: false,
  });
  const openNarrow = (section) => {
    setIsOpen({ ...isOpen, [section]: !isOpen[section] });
  };
  const openFilteredResultNarrow = (filteredResult)=> {
    setIsOpen(
      Object.keys(filteredResult)?.reduce((acc, key) => {
        acc[key] = filteredResult[key]?.length > 0
        return acc
      }, {})
    )
  }
  const [contentSelections, setContentSelections] = useState(contentSections);
  const [filterKey, setFilterKey] = useState('');
  const [selectedSections, setSelectedSections] = useState(settedParams);

  useEffect(() => {
    setSelectedSections(settedParams);
  }, [settedParams]);

  useEffect(() => {
    setFilterKey('');
    setIsOpen({});
  }, [show]);

  useEffect(()=>{
    if (!filterKey) {
      setContentSelections(contentSections);
      setIsOpen({});
      return
    }
    let filteredResult = {};
    Object.keys(contentSections).map(
      (key) =>
      (filteredResult[key] = contentSections[key].filter(
        (val) => val.toLowerCase().indexOf(filterKey.toLowerCase()) >= 0,
      )),
    );
    setContentSelections(filteredResult);
    openFilteredResultNarrow(filteredResult)
  }, [filterKey])

  return (
    <div className="content-add-button-selection-area">
      {/* <input className="content-add-button-selection-filter" /> */}
      <div className="filterable-search-bar content-add-button-selection-filter">
        <Image
          src={Search}
          className="filterable-search-bar-icon search_bar_icon"
        />
        <input
          autoFocus
          className="filterable-search-bar-input"
          placeholder="Search for..."
          onChange={(e) => {
            const value = e.target.value;
            setFilterKey(value);
          }}
          value={filterKey}
        />
      </div>
      <div className="content-add-button-selection-section-area">
        {Object.keys(contentSelections).map((section) => {
          return (
            <>
              <div className="content-add-button-selection-section">
                <label>{section}</label>
                <div
                  className="margin-left-auto"
                  style={{ padding: "1px 6px", cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    openNarrow(section);
                  }}
                >
                  <Image
                    src={NarrowUp}
                    className={`filterable-toogle-area-indicator ${
                      isOpen[section] ? 'rtoate180' : ''
                    }`}
                  />
                </div>
              </div>
              {isOpen?.[section]
                ? contentSelections[section].map((val, index) => {
                    if (
                      selectedSections.includes(val) &&
                      ![
                        contentEnum.additionalDataFromCustomers,
                        contentEnum.additionalDataFromTransactionRecords,
                        contentEnum.additionalDataFromPurchasedItems,
                      ].includes(val)
                    ) {
                      return null;
                    }
                    return (
                      <Dropdown.Item
                        onClick={() => {
                          sectionSelectAction(val);
                          setSelectedSections([...selectedSections, val]);
                        }}
                      >
                        <div className="display-flex-area">
                          <div className="li-icon" />
                          <label className="li-label">{val}</label>
                        </div>
                      </Dropdown.Item>
                      // <div
                      //   className="display-flex-area drop-item"
                      //   onClick={() => {
                      //     sectionSelectAction(val);
                      //     setSelectedSections([...selectedSections, val]);
                      //   }}
                      //   role="button"
                      // >
                      //   <div className="li-icon" />
                      //   <label className="li-label">{val}</label>
                      // </div>
                    );
                  })
                : null}
            </>
          );
        })}
      </div>
    </div>
  );
}

const AccountStatusDropdown = (
  subIndex,
  groupName,
  title,
  conditionName,
) => {
  const { setValue, control} = useFormContext();
  const fixedFieldName = `${conditionName}.${subIndex}.${groupName}.accountStatus`;
  return (
    <div className="d-flex flex-column">
      <CustomTitleLabel title={title} />
      <Controller
        control={control}
        name={fixedFieldName}
        render={({ field }) => (
          <OnlyDropdown
            toggleText={field.value ? DISPLAY_ACCOUNT_STATUS_TYPE?.[field.value] : "Please select"}
            options={[
              ACCOUNT_STATUS_TYPE.ACTIVE,
              ACCOUNT_STATUS_TYPE.TEMPORARY_EARNING,
              ACCOUNT_STATUS_TYPE.TEMPORARY,
              ACCOUNT_STATUS_TYPE.PROSPECT,
            ].map(accountStatusType => ({
              pk: accountStatusType,
              name: DISPLAY_ACCOUNT_STATUS_TYPE?.[accountStatusType] || accountStatusType,
              value: accountStatusType
            }))}
            setValue={(value) => {
              setValue(fixedFieldName, value, { shouldDirty: true });
            }}
        />
        )}
      />
    </div>)
}

const getDropdownToMutipleSelector = (
  subIndex,
  groupName,
  title,
  options,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <DropdownToMutipleSelector
      fieldBaseName={fieldBaseName}
      title={title}
      mutipleSelector={{
        options,
      }}
    />
  );
};

const getLookupWithMutipleNumber = (
  subIndex,
  groupName,
  title,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <LookupWithMutipleNumber
      fieldBaseName={fieldBaseName}
      groupName={groupName}
      title={title}
    />
  );
};

const getTimePeriodInput = (
  subIndex,
  groupName,
  title,
  hasNumber,
  rangeOptions,
  conditionName,
  timeSelectorDescription,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <InputWithMutipleDropDown
      fieldBaseName={fieldBaseName}
      title={title}
      hasNumber={hasNumber}
      rangeOptions={rangeOptions}
      hasPeriodDropdown
      timeSelectorDescription={timeSelectorDescription}
    />
  );
};

const FormSwitch = ({ fieldName }) => {
  const { setValue, control } = useFormContext();
  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field }) => (
        <CustomSwitchButton
          defaultChecked={field.value}
          onChange={(isChecked) => {
            setValue(field.name, isChecked, { shouldDirty: true });
          }}
        />
      )}
    />
  );
};

const getCustomTitleWithSwitch = (
  subIndex,
  groupName,
  title,
  tips,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <div className="d-flex flex-column">
      <CustomTitleLabel title={title} />
      <FormSwitch fieldName={`${fieldBaseName}.enable`} />
      {tips ? <label className="tips-message">{tips}</label> : null}
    </div>
  );
};

const getCampaignView = (subIndex, groupName, title, conditionName, timeSelectorDescription = "") => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <CampaignBehavioralSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
      timeSelectorDescription={timeSelectorDescription}
    />
  );
};

const getAcquireOrUsedCouponView = (
  subIndex,
  groupName,
  title,
  conditionName,
  timeSelectorDescription,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <CouponBehavioralSection title={title} fieldBaseName={fieldBaseName} timeSelectorDescription={timeSelectorDescription} />
  );
};

const getViewWithTransactionTypeFilter = (
  subIndex,
  subRenderFunc,
  subRenderArgs,
  groupName,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <div>
      {subRenderFunc(subIndex, ...subRenderArgs)}
      <TransactionTypeMutipleSelector fieldBaseName={fieldBaseName} />
    </div>
  );
};

const getProductCategory = (subIndex, groupName, conditionName) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <div className="d-flex flex-column">
      <ProductCategoryMultipleSelector fieldBaseName={fieldBaseName} />
      <TransactionTypeMutipleSelector fieldBaseName={fieldBaseName} />
    </div>
  );
};

const getNumberOfTransactionSection = (
  subIndex,
  title,
  groupName,
  conditionName,
  timeSelectorDescription,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <NumberOfTransactionSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
      timeSelectorDescription={timeSelectorDescription}
    />
  );
};

const getTotalSpendingSection = (
  subIndex,
  title,
  groupName,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <div>
      {getLookupWithMutipleNumber(subIndex, groupName, title, conditionName)}
      {getTimePeriodInput(
        subIndex, 
        groupName,
        "Time period",
        false,
        [
          PERIOD_TYPE_DISPLAY.ALL_THE_TIME,
          PERIOD_TYPE_DISPLAY.WITHIN,
          PERIOD_TYPE_DISPLAY.EQUAL_TO,
          PERIOD_TYPE_DISPLAY.BETWEEN,
          PERIOD_TYPE_DISPLAY.AFTER,
          PERIOD_TYPE_DISPLAY.BEFORE,
        ],
        conditionName,
      )}
      <TransactionTypeMutipleSelector fieldBaseName={fieldBaseName} />
    </div>
  );
};

const getDiscountLoverSection = (subIndex, title, groupName, conditionName, timeSelectorDescription) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <DiscountLoverSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
      timeSelectorDescription={timeSelectorDescription}
    />
  );
};

const getPurchaseInStoreSection = (
  subIndex,
  title,
  groupName,
  conditionName,
  timeSelectorDescription,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <PurchaseInStoreSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
      timeSelectorDescription={timeSelectorDescription}
    />
  );
};

const getAdditionalDataSection = (
  subIndex,
  title,
  groupName,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <AdditionalDataSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
    />
  );
};

const getMessageTrackingSection = (
  subIndex,
  title,
  groupName,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <MessageTrackingSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
    />
  );
};

const getPointsToExpireSection = (
  subIndex,
  title,
  groupName,
  conditionName,
) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <PointsToExpireSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
    />
  );
};

const getTotalPointsEarnedSection = (
  subIndex,
  groupName,
  title,
  conditionName,
)=>{
  return (
    <div>
      {getLookupWithMutipleNumber(subIndex, groupName, title, conditionName)}
      {getTimePeriodInput(
        subIndex,
        groupName,
        "Time period",
        false,
        [
          PERIOD_TYPE_DISPLAY.ALL_THE_TIME,
          PERIOD_TYPE_DISPLAY.WITHIN,
          PERIOD_TYPE_DISPLAY.EQUAL_TO,
          PERIOD_TYPE_DISPLAY.BETWEEN,
          PERIOD_TYPE_DISPLAY.AFTER,
          PERIOD_TYPE_DISPLAY.BEFORE,
        ],
        conditionName,
      )}
    </div>
  );
}

const getLastPurchaseSection = (subIndex, title, groupName, conditionName, timeSelectorDescription) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <LastPurchaseSection
      title={title}
      groupName={groupName}
      fieldBaseName={fieldBaseName}
      timeSelectorDescription={timeSelectorDescription}
    />
  );
};

const getPpReachTargetSection = (subIndex, title, groupName, conditionName) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <ProgressionPointsReachTargetSection
      title={title}
      fieldBaseName={fieldBaseName}
    />
  );
};

const getLevelSoonExpireSection = (subIndex, title, groupName, conditionName) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return (
    <LevelSoonExpireSection
      title={title}
      fieldBaseName={fieldBaseName}
    />
  );
};

const DropdownSelectorSection = (subIndex, title, groupName, conditionName) => {
  const { watch, control } = useFormContext();

  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  const valueFieldName = `${fieldBaseName}.earningRule`

  const watchEarningRule = watch(valueFieldName)
  return (
    <Controller
      control={control}
      name={valueFieldName}
      rules={{ required: "Please provide an earning rule" }}
      render={() => (
        <div className='width-400px'>
          <EarningRuleDropdownWithButtonAndPrompt
            title={title}
            valueFieldName={valueFieldName}
            placeholder={"Select earning rule"}
            dropDownSearchBarPlaceholder={"Search by ID, name"}
            hasAddButton={false}
            defaultFilter={{
              otherSearch: {
                requirePromotionCode: true,
                typeIn: [
                  EarningRuleType.newMember,
                ],
              },
            }}
            isPrompt
          />
          {watchEarningRule?.pk && <div>{`Promotion code: ${watchEarningRule?.newMemberTypePromotionCode}`}</div>}
        </div>
      )}
    />
  )
}


const CustomFieldController = ({ fieldName, value }) => {
  const { setValue, control } = useFormContext();

  useEffect(() => {
    setValue(fieldName, value, { shouldDirty: false });
  }, []);

  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field }) => <></>}
    />
  );
};

const getCustomRecencyFrequencyMonetaryTitle = (
  subIndex,
  conditionName,
  scoreDefinition,
  name,
) => {
  const fieldName = `${conditionName}.${subIndex}.${
    contentGroupEnum[contentEnum.champions]
  }.scoreDefinition`;

  return (
    <div>
      <CustomTitleLabel title={`RFM - ${name}`} />
      <CustomFieldController fieldName={fieldName} value={scoreDefinition} />
    </div>
  );
};

const getRecencyFrequencyMonetaryFieldNumber = (fields = []) => {
  let number = 0;
  fields.forEach((item) => {
    if (scoreDefinitionNameList.indexOf(item.title) > -1) {
      number += 1;
    }
  });
  return number;
};

const getSignUpEmailDamainSection = (subIndex, title, conditionName, groupName) => {
  const fieldBaseName = `${conditionName}.${subIndex}.${groupName}`;
  return <SignUpEmailDomainSection
    title={title}
    fieldBaseName={fieldBaseName}
  />
}

function SingleConditionInputSection({
  levels,
  countryCodes,
  index,
  conditionGroupKey,
  removeConditionGroups
}) {
  const {
    control,
    register,
    formState: { errors },
    watch,
    reset,
    getValues,
  } = useFormContext();
  const watchSegmentType = watch("segmentType")
  const timeSelectorDescription = watchSegmentType === SEGMENT_TYPE.DYNAMIC
    ? "[Reminder] If select a time period that has passed, the customer will not be dynamically updated. Please select “Static” type segment instead."
    : null
  const conditionIndex = index + 1;
  const conditionName = `conditionGroups.${index}.conditions`;
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: conditionName,
  });
  // console.log("@@698", fields)
  const [showResetPrompt, setShowResetPrompt] = useState(false);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const contentSectionComponment = {
    [contentEnum.accountStatus]: {
      renderer: AccountStatusDropdown,
      rendererArgs: [
        contentGroupEnum[contentEnum.accountStatus],
        contentEnum.accountStatus,
        conditionName,
      ],
    },
    [contentEnum.gender]: {
      renderer: getDropdownToMutipleSelector,
      rendererArgs: [
        contentGroupEnum[contentEnum.gender],
        contentEnum.gender,
        GenderOptions,
        conditionName,
      ],
    },
    [contentEnum.birthday]: {
      renderer: getDropdownToMutipleSelector,
      rendererArgs: [
        contentGroupEnum[contentEnum.birthday],
        contentEnum.birthday,
        MonthOptions,
        conditionName,
      ],
    },
    [contentEnum.age]: {
      renderer: getLookupWithMutipleNumber,
      rendererArgs: [
        contentGroupEnum[contentEnum.age],
        contentEnum.age,
        conditionName,
      ],
    },
    [contentEnum.countryCode]: {
      renderer: getDropdownToMutipleSelector,
      rendererArgs: [
        contentGroupEnum[contentEnum.countryCode],
        contentEnum.countryCode,
        countryCodes,
        conditionName,
      ],
    },
    [contentEnum.signupAnniversary]: {
      renderer: getLookupWithMutipleNumber,
      rendererArgs: [
        contentGroupEnum[contentEnum.signupAnniversary],
        contentEnum.signupAnniversary,
        conditionName,
      ],
    },
    [contentEnum.level]: {
      renderer: getDropdownToMutipleSelector,
      rendererArgs: [
        contentGroupEnum[contentEnum.level],
        contentEnum.level,
        levels,
        conditionName,
      ],
    },

    [contentEnum.lastPurchase]: {
      renderer: getLastPurchaseSection,
      rendererArgs: [
        contentEnum.lastPurchase,
        contentGroupEnum[contentEnum.lastPurchase],
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.numberOfTransaction]: {
      renderer: getNumberOfTransactionSection,
      rendererArgs: [
        contentEnum.numberOfTransaction,
        contentGroupEnum[contentEnum.numberOfTransaction],
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.totalSpending]: {
      renderer: getTotalSpendingSection,
      rendererArgs: [
        contentEnum.totalSpending,
        contentGroupEnum[contentEnum.totalSpending],
        conditionName,
      ],
    },
    [contentEnum.averageTransaction]: {
      renderer: getViewWithTransactionTypeFilter,
      rendererArgs: [
        getLookupWithMutipleNumber,
        [
          contentGroupEnum[contentEnum.averageTransaction],
          contentEnum.averageTransaction,
          conditionName,
        ],
        contentGroupEnum[contentEnum.averageTransaction],
        conditionName,
      ],
    },
    [contentEnum.newMember]: {
      renderer: getTimePeriodInput,
      rendererArgs: [
        contentGroupEnum[contentEnum.newMember],
        contentEnum.newMember,
        false,
        [
          PERIOD_TYPE_DISPLAY.WITHIN,
          PERIOD_TYPE_DISPLAY.EQUAL_TO,
          PERIOD_TYPE_DISPLAY.BETWEEN,
          PERIOD_TYPE_DISPLAY.AFTER,
          PERIOD_TYPE_DISPLAY.BEFORE,
        ],
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.emailDomain]: {
      renderer: getSignUpEmailDamainSection,
      rendererArgs: [
        contentEnum.emailDomain,
        conditionName,
        contentGroupEnum[contentEnum.emailDomain],
      ],
    },
    [contentEnum.newSignupWithReferral]: {
      renderer: getCustomTitleWithSwitch,
      rendererArgs: [
        contentGroupEnum[contentEnum.newSignupWithReferral],
        contentEnum.newSignupWithReferral,
        null,
        conditionName,
      ],
    },
    [contentEnum.newSignupWithPromotionCode]: {
      renderer: DropdownSelectorSection,
      rendererArgs: [
        contentEnum.newSignupWithPromotionCode,
        contentGroupEnum[contentEnum.newSignupWithPromotionCode],
        conditionName,
      ],
    }, 
    [contentEnum.numberOfLogin]: {
      renderer: (subIndex) => {
        const fieldBaseName = `${conditionName}.${subIndex}.${
          contentGroupEnum[contentEnum.numberOfLogin]
        }`;
        const fieldName = `${fieldBaseName}.numberOfLogin`;
        return (
          <div className="d-flex flex-column">
            <CustomTitleLabel title={contentEnum.numberOfLogin} />
            <div style={{ display: 'flex' }}>
              <input
                type="number"
                min={'0'}
                className={`custom-number-input-short ${
                  hasReactHookFormError(errors, fieldName) ? 'error-field' : ''
                }`}
                {...register(fieldName, {
                  required: 'This field is required.',
                })}
              />
              <label className="help-message margin-left-10-percent margin-top-8-percent">
                times
              </label>
            </div>
            <CustomErrorMessage name={fieldName} />
          </div>
        );
      },
      rendererArgs: [],
    },
    [contentEnum.lastLogin]: {
      renderer: getTimePeriodInput,
      rendererArgs: [
        contentGroupEnum[contentEnum.lastLogin],
        contentEnum.lastLogin,
        false,
        [
          PERIOD_TYPE_DISPLAY.ALL_THE_TIME,
          PERIOD_TYPE_DISPLAY.WITHIN,
          PERIOD_TYPE_DISPLAY.EQUAL_TO,
          PERIOD_TYPE_DISPLAY.BETWEEN,
          PERIOD_TYPE_DISPLAY.AFTER,
          PERIOD_TYPE_DISPLAY.BEFORE,
        ],
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.campaignViewed]: {
      renderer: getCampaignView,
      rendererArgs: [
        contentGroupEnum[contentEnum.campaignViewed],
        contentEnum.campaignViewed,
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.acquireOrUsedCoupon]: {
      renderer: getAcquireOrUsedCouponView,
      rendererArgs: [
        contentGroupEnum[contentEnum.acquireOrUsedCoupon],
        contentEnum.acquireOrUsedCoupon,
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.earnReward]: {
      renderer: getCampaignView,
      rendererArgs: [
        contentGroupEnum[contentEnum.earnReward],
        contentEnum.earnReward,
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.totalPointsEarned]: {
      renderer: getTotalPointsEarnedSection,
      rendererArgs: [
        contentGroupEnum[contentEnum.totalPointsEarned],
        contentEnum.totalPointsEarned,
        conditionName,
      ],
    },
    [contentEnum.pointsToExpire]: {
      renderer: getPointsToExpireSection,
      rendererArgs: [
        contentEnum.pointsToExpire,
        contentGroupEnum[contentEnum.pointsToExpire],
        conditionName,
      ],
    },
    [contentEnum.levelSoonToExpire]: {
      renderer: getLevelSoonExpireSection,
      rendererArgs: [
        contentEnum.levelSoonToExpire,
        contentGroupEnum[contentEnum.levelSoonToExpire],
        conditionName,
      ],
    },
    [contentEnum.ppAlmostReachTarget]: {
      renderer: getPpReachTargetSection,
      rendererArgs: [
        contentEnum.ppAlmostReachTarget,
        contentGroupEnum[contentEnum.ppAlmostReachTarget],
        conditionName,
      ],
    },
    [contentEnum.products]: {
      renderer: (subIndex) => {
        const fieldBaseName = `${conditionName}.${subIndex}.${
          contentGroupEnum[contentEnum.products]
        }`;
        const fieldName = `${fieldBaseName}.productSkus`;
        return (
          <div className="d-flex flex-column">
            <CustomTitleLabel title={contentEnum.products} />
            <label className="tips-message">
              {"Separate the SKUs by comma."}
            </label>
            <textarea
              className={`custom-textarea-input-box custom-textarea-input-font ${
                hasReactHookFormError(errors, fieldName) ? 'error-field' : ''
              }`}
              {...register(fieldName, { required: 'This field is required.' })}
            />
            <CustomErrorMessage name={fieldName} />
            <TransactionTypeMutipleSelector fieldBaseName={fieldBaseName} />
          </div>
        );
      },
      rendererArgs: [],
    },
    [contentEnum.eComBindStatus]: {
      renderer: getCustomTitleWithSwitch,
      rendererArgs: [
        contentGroupEnum[contentEnum.eComBindStatus],
        contentEnum.eComBindStatus,
        null,
        conditionName,
      ],
    },
    [contentEnum.productCategory]: {
      renderer: getProductCategory,
      rendererArgs: [
        contentGroupEnum[contentEnum.productCategory],
        conditionName,
      ],
    },
    [contentEnum.discountLover]: {
      renderer: getDiscountLoverSection,
      rendererArgs: [
        contentEnum.discountLover,
        contentGroupEnum[contentEnum.discountLover],
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.purchaseInStore]: {
      renderer: getPurchaseInStoreSection,
      rendererArgs: [
        contentEnum.purchaseInStore,
        contentGroupEnum[contentEnum.purchaseInStore],
        conditionName,
        timeSelectorDescription,
      ],
    },
    [contentEnum.additionalDataFromCustomers]: {
      renderer: getAdditionalDataSection,
      rendererArgs: [
        contentEnum.additionalDataFromCustomers,
        contentGroupEnum[contentEnum.additionalDataFromCustomers],
        conditionName,
      ],
    },
    [contentEnum.additionalDataFromTransactionRecords]: {
      renderer: getAdditionalDataSection,
      rendererArgs: [
        contentEnum.additionalDataFromTransactionRecords,
        contentGroupEnum[contentEnum.additionalDataFromTransactionRecords],
        conditionName,
      ],
    },
    [contentEnum.additionalDataFromPurchasedItems]: {
      renderer: getAdditionalDataSection,
      rendererArgs: [
        contentEnum.additionalDataFromPurchasedItems,
        contentGroupEnum[contentEnum.additionalDataFromPurchasedItems],
        conditionName,
      ],
    },
    [contentEnum.messageTracking]: {
      renderer: getMessageTrackingSection,
      rendererArgs: [
        contentEnum.messageTracking,
        contentGroupEnum[contentEnum.messageTracking],
        conditionName,
      ],
    },
  };

  scoreDefinitionList.forEach((item) => {
    contentSectionComponment[item.name] = {
      renderer: getCustomRecencyFrequencyMonetaryTitle,
      rendererArgs: [conditionName, item.value, item.name],
    };
  });
  const recencyFrequencyMonetaryFieldNumber =
    getRecencyFrequencyMonetaryFieldNumber(fields);

  return (
    <>
      <div className="content-area">
        <div className="title-in-block">
          <label className="create-section-title">
            AND Condition group {conditionIndex}
          </label>
          {fields.length > 0 ? (
            <button
              type="button"
              className="btn-link reset-button"
              onClick={() => setShowResetPrompt(true)}
            >
              Reset
            </button>
          ) : null}
          <button
            className="delete-condition-group-button"
            type="button"
            onClick={() => {
              replace([]);
              removeConditionGroups(index);
              reset({ ...getValues() });
            }}
          >
            <Image src={DeleteIcon} className="content-delete-button" />
          </button>
        </div>
        <div className="title-error-area">
          <ErrorFieldMessage
            id={`condition-group-${conditionIndex}-rfm-error`}
            error={recencyFrequencyMonetaryFieldNumber > 1}
            message='There will be no result if multiple RFM segments are selected with "AND" relationships. Try using "OR" relationships instead or selecting a single RFM segment only.'
          />
        </div>
        {fields.map((item, subIndex) => {
          const componmentConfig = contentSectionComponment[item.title];
          return (
            <div key={`condition-group-${conditionGroupKey}-${item.title}-${subIndex}`}>
              <div className="display-flex-area and-condition">
                {componmentConfig &&
                  componmentConfig.renderer(
                    subIndex,
                    ...componmentConfig.rendererArgs,
                  )}
                <button
                  className="reset-button content-delete-button-area"
                  type="button"
                  onClick={() => {
                    remove(subIndex);
                    reset({ ...getValues() });
                  }}
                >
                  <Image src={DeleteIcon} className="content-delete-button" />
                </button>
              </div>
              <div className="content-condition-area">
                <div className="content-condition-dash"></div>
                <label>AND</label>
              </div>
            </div>
          );
        })}
        <Dropdown
          show={isShowDropdown}
          onToggle={(isOpen) => {
            setIsShowDropdown(isOpen);
          }}
        >
          <Dropdown.Toggle
            className="btn-back-button-common content-add-button"
            variant="none"
            id={`dropdown-${conditionIndex}`}
          >
            + Add AND Condition
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ zIndex: 2 }}>
            <ContentFilterDropDown
              show={isShowDropdown}
              sectionSelectAction={(section) => {
                append({ title: section });
              }}
              settedParams={fields?.map((item) => item.title)}
            />
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <BasePrompt
        show={showResetPrompt}
        title={`Reset condition group ${conditionIndex}`}
        description={'Did you confirm to reset this content section?'}
        closeAction={() => setShowResetPrompt(false)}
        leftButton={{
          text: 'Cancel',
          action: () => {
            setShowResetPrompt(false);
          },
        }}
        rightButton={{
          text: 'Delete',
          action: () => {
            replace([]);
            reset({ ...getValues() });
            setShowResetPrompt(false);
          },
        }}
      />

      <div className="content-condition-area content-condition-or-area">
        <div className="content-condition-solid"></div>
        <label>OR</label>
      </div>
    </>
  );
}
const mapPropsToState = (state) => ({
  levels: state.levels.levelList,
  countryCodes: state.settings.countryCodes,
  // segment: state.segments.tempSegment,
  // createErrorDict: state.segments.createErrorDict,
  // tempSegmentConditionGroup: state.segments.tempSegment?.conditionGroup,
});

export default connect(mapPropsToState)(SingleConditionInputSection);
